import { getVisitLiteFlag } from 'src/utils/localstorageAccess';

// 这里放置一些common state
const state = {
  currentLang: 'en',
  isShowAlarm: false,
  showAdblockAlert: false,
  // 是否要访问移动端的弹窗
  showVisitLiteTips: getVisitLiteFlag().show,
  // 降级需求 notify提示框显示与否的判断字段
  isShowDemoteNotify: false,
  // TTP 降级
  isShowTTPDemoteNotify: false,
  isAthenaCallerReady: false, // 雅典娜智能客服是否加载完成
  hasAthenaCaller: false, // 是否有雅典娜智能客服
  hasAthenaCallerCheckCompleted: false, // 是否需要加载雅典娜智能客服的判断完成
};
export default state;
